module.exports = __webpack_public_path__ + "static/media/logo.401680ab.svg";